import { createContext, useContext, ReactNode, useEffect } from "react";

import { useAuthContextUtils } from "./utils";



type AuthContextType = {
  token: string | null;
  stateParams: string | null;
  loading: boolean;
  error: string | null;
  userData: {} | null;
  /** Explicitly signed out in this browser; SSO is not auto-started. */
  signedOut: boolean;
  signIn: () => void;
  signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

type AuthProviderProps = {
  children: ReactNode;
}

export function AuthProvider({
  children
}: AuthProviderProps) {
  const {
    authenticateUser, signIn, signOut, signedOut,
    stateParams, userData, loading, token, error
  } = useAuthContextUtils();

  useEffect(() => {
    authenticateUser();
  }, []);



  return (
    <AuthContext.Provider
      value={{
        token,
        stateParams,
        loading,
        userData,
        error,
        signedOut,
        signIn,
        signOut
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}



export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}